import { BaseControlModel } from './base-control-model';

export interface ZoneInfo {
  value_name: string;
  value_type: string;
  value: number;
  value_units: string;
  room_temp: boolean;
}

export class ZoneModel extends BaseControlModel {
  public zone_id: string;
  public zone_name: string;
  public zone_type: string;
  public zone_info: {
    value_list: Array<ZoneInfo> | ZoneInfo;
  };
  public zone_total_power: number;
  public zone_total_power_units: string;
  public active_lights: number;
  public active_dimmer_lights: number;
  public active_rgbw_lights: number;
  public active_devices: number;
  public cool_state: boolean;
  public heat_state: boolean;
  public zone_used_controls: {
    audio_count: number;
    blinds_count: number;
    cool_count: number;
    devices_count: number;
    dimmer_count: number;
    fan_count: number;
    heat_count: number;
    lights_count: number;
    rgbw_count: number;
    scenes_count: number;
    used_audio: number;
    used_blinds: number;
    used_cool: number;
    used_devices: number;
    used_heat: number;
    used_lights: number;
    used_scenes: number;
  };

  public override init() {
    super.init();
    this.name = this.zone_name;
  }
}
